import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUploadedResourceId, isSending } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import { addResource, getResourceDetails, updateResource } from "../../../../actions/rmsActions";
import { clearErrors } from "../../../../actions/commonActions";
import ResourceFormDialog from "./ResourceFormDialog";


function ResourceFormContainer({ onClose, resource, appCode, ...props }) {
    const [title, setTitle] = useState(resource ? resource.title : "");
    const handleSetTitle = (event) => setTitle(event.target.value);

    const [description, setDescription] = useState(resource ? resource.description : "");
    const handleSetDescription = (event) => setDescription(event.target.value);

    const uploading = useSelector((state) => isSending(state, DataTypes.RESOURCE));
    const uploaded = useSelector(getUploadedResourceId);
    const dispatch = useDispatch();

    const handleUpload = () => {
        clearErrors(dispatch);
        if (!!resource && !!resource.id) {
            dispatch(updateResource(appCode, resource.id, title, description));
        } else {
            dispatch(addResource(appCode, title, description, selectedFile));
        }
    };

    useEffect(() => {
        if (!uploading && !!uploaded) {
            dispatch(getResourceDetails(uploaded, appCode));
            onClose();
        }
    });

    const [selectedFile, setSelectedFile] = useState();
    const handleSelectFile = (event) => setSelectedFile(event.target.files[0] || null);

    return (
        <ResourceFormDialog
            action={!!resource ? "Edit" : "Add"}
            confirmButton={!!resource ? "Save" : "Add"}
            type="file"
            onClose={onClose}
            title={title}
            setTitle={handleSetTitle}
            description={description}
            setDescription={handleSetDescription}
            file={selectedFile}
            setFile={!resource && handleSelectFile}
            isUploading={uploading}
            onUpload={handleUpload}
            scroll="paper"
            {...props}
        />
    );
}

export default ResourceFormContainer;
